export enum LastActiveTypeEnum {
    OnlineNow = 1,
    Under30Min = 2,
    Under1Hr = 3,
    Under8Hr = 4,
    Under24Hr = 5,
    Under72Hr = 6, //Меньше 3 дней
    Under120Hr = 7, //Меньше 5 дней
    Under168Hr = 8, //Меньше 7 дней
    More168Hr = 9, //Больше 7 дней
    Never = 10, //Никогда
}
